import { render, staticRenderFns } from "./manageDataDialog.vue?vue&type=template&id=2c601b18&scoped=true&"
import script from "./manageDataDialog.vue?vue&type=script&lang=js&"
export * from "./manageDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./manageDataDialog.vue?vue&type=style&index=0&id=2c601b18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c601b18",
  null
  
)

export default component.exports